
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seedance-2-5-ai-video-generator",
      function () {
        return require("private-next-pages/seedance-2-5-ai-video-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seedance-2-5-ai-video-generator"])
      });
    }
  